import React, { useMemo } from "react";
import {
  getEventPosition,
  handleTaskNameClick,
  TaskIcon,
} from "../../helper/helper";
import AssociatedEntity from "../../AssociatedEntity/AssociatedEntity";
import TastStatus from "../../TastStatus/TastStatus";

const AgendaTaskCard = ({ event, showTime = true }) => {
  const isTodo = event.category === 1;

  // Memoize the formatted time and position calculation
  const formattedTime = useMemo(
    () =>
      new Date(event.auditDetails?.dueDateLocalTime)
        .toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .toUpperCase(),
    [event.auditDetails.dueDateLocalTime]
  );

  const { startPosition, endPosition } = getEventPosition(event);
  const time = useMemo(
    () => endPosition - startPosition,
    [startPosition, endPosition]
  );

  return (
    <div className="agenda-task-card ng_p_2_r">
      {showTime && (
        <div className="time-details">
          <label className="time">{formattedTime}</label>
          {!isTodo && <label className="duration">{time} min</label>}
        </div>
      )}
      <div className="task-card-content overflow-ellipsis ng_p_2_r">
        <TastStatus event={event} />
        <TaskIcon event={event} />
        <div className="task-name-lead overflow-ellipsis">
          <div
            className="event-name overflow-ellipsis ng_p_2_sb"
            onClick={() => handleTaskNameClick(event)}
          >
            {event.name}
          </div>

          {event.relatedEntity?.relatedEntityIdName && (
           <AssociatedEntity event={event}/>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgendaTaskCard;
